import { TranslatableErrorMessage } from "../redux/models/refsixState";

export const watchVersionMismatchError: TranslatableErrorMessage = {
    messageKey: "fixture.Fixture.mismatchFailure.description",
    color: "warning",
};
